import { AxiosError } from 'axios'
import { useAlertModal } from '@/stores/alertModal'
import { t } from '@/Support/lang'

export const alertError = (error: AxiosError, statusError?: number) => {
  const { newErrorAlert, newOptionErrorAlert } = useAlertModal()
  const errorData = error.response?.data
  if (errorData) {
    switch (statusError) {
      case 402:
        newOptionErrorAlert(
          t('Error'),
          errorData.message,
          t('roles.payment-required-modal.button-label'),
          () => {
            window.location.href = '/billing'
          },
        )
        break

      default:
        newErrorAlert(t('Error'), errorData.message)
        break
    }
  }
}
